import React from "react"
import { Box, Paper, Typography } from "@mui/material"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableRow from "@mui/material/TableRow"
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone"
import ChatTwoToneIcon from "@mui/icons-material/ChatTwoTone"
import CheckBoxTwoToneIcon from "@mui/icons-material/CheckBoxTwoTone"
import CheckBoxOutlineBlankTwoToneIcon from "@mui/icons-material/CheckBoxOutlineBlankTwoTone"

const getStatus = (status, action) => {
  switch (status) {
    case "search":
      return (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Typography variant="body2" sx={{ textAlign: "right" }}>
            <SearchTwoToneIcon fontSize="small" sx={{ display: "inline", verticalAlign: "middle", mr: 0.5 }} />
            {action === "buy" ? "Verkäufer wird gesucht" : "Käufer wird gesucht"}
          </Typography>
        </Box>
      )
    case "matched":
      return (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Typography variant="body2" sx={{ textAlign: "right" }}>
            <ChatTwoToneIcon fontSize="small" sx={{ color: "primary.main", display: "inline", verticalAlign: "middle", mr: 0.5 }} />
            {action === "buy" ? "Verkäufer gefunden" : "Käufer gefunden"}
          </Typography>
        </Box>
      )
    case "finished":
      return (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Typography variant="body2" sx={{ textAlign: "right" }}>
            <CheckBoxTwoToneIcon fontSize="small" sx={{ display: "inline", verticalAlign: "middle", mr: 0.5 }} />
            {action === "buy" ? "Kauf abgeschlossen" : "Verkauf abgeschlossen"}
          </Typography>
        </Box>
      )
    default:
      return (
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Typography variant="body2" sx={{ textAlign: "right" }}>
            <CheckBoxOutlineBlankTwoToneIcon fontSize="small" sx={{ display: "inline", verticalAlign: "middle", mr: 0.5 }} />
            Nicht eingestellt
          </Typography>
        </Box>
      )
  }
}

const BookInfoTable = ({ book, isMobile, bookInLedger }) => {
  const { title, isbn, subject, grade, priceOriginal, publisher, comment, isBundle } = book
  const status = bookInLedger?.status
  const action = bookInLedger?.action

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          <TableRow sx={{ backgroundColor: "#eee" }}>
            <TableCell align="left" sx={{ pr: 0 }}>
              Status
            </TableCell>
            <TableCell align="right" sx={{ pl: 0 }}>
              {getStatus(status, action)}
            </TableCell>
          </TableRow>
          {isMobile ? (
            <></>
          ) : (
            <TableRow>
              <TableCell align="left">Titel</TableCell>
              <TableCell align="right">{title}</TableCell>
            </TableRow>
          )}

          <TableRow>
            <TableCell align="left">Klasse</TableCell>
            <TableCell align="right">{grade}</TableCell>
          </TableRow>
          {!isBundle && (
            <>
              <TableRow>
                <TableCell align="left">Fach</TableCell>
                <TableCell align="right">{subject}</TableCell>
              </TableRow>
              {/* eslint-disable-next-line */}
              {!!isbn && isbn != 0 ? (
                <TableRow>
                  <TableCell align="left">ISBN</TableCell>
                  <TableCell align="right">{isbn}</TableCell>
                </TableRow>
              ) : (
                <></>
              )}
              {publisher ? (
                <TableRow>
                  <TableCell align="left">Verlag</TableCell>
                  <TableCell align="right">{publisher}</TableCell>
                </TableRow>
              ) : (
                <></>
              )}
              {priceOriginal ? (
                <TableRow>
                  <TableCell align="left">Originalpreis</TableCell>
                  <TableCell align="right">
                    {priceOriginal.toLocaleString("de-DE", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}{" "}
                    €
                  </TableCell>
                </TableRow>
              ) : (
                <></>
              )}
            </>
          )}
          <TableRow>
            <TableCell align="left">Endgültiger Preis</TableCell>
            <TableCell align="right">Nach Absprache mit Partner</TableCell>
          </TableRow>
          {comment || isBundle ? (
            <TableRow>
              <TableCell align="left">Information</TableCell>
              <TableCell align="right">{isBundle ? `Alle Bücher der Klasse ${grade} zusammen.` : comment}</TableCell>
            </TableRow>
          ) : (
            <></>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default BookInfoTable
